import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import LoyaltyLockIcon from '~/icons/components/LoyaltyLockIcon';
import { LoyaltyTiers } from '~/shared/constants/loyaltyTiers';
import { ProductTag } from '~/shared/constants/products';
import { isLockedToMember } from '~/shared/utils/loyalty';
import { useLoyalty } from '~/techstyle-shared/react-accounts';

const LockedTreatmentContainer = styled.div`
  position: relative;
  overflow: hidden;
`;

const OverlayWrapper = styled.div`
  filter: contrast(0.3) brightness(1.5);
`;

const LockIconContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: black;
  width: 30px;
  height: 30px;
  border-radius: 50%;
`;

const ProductCardImageLockedTreatmentWrapper = ({
  tagIdList = [],
  children,
}) => {
  const { tier } = useLoyalty();
  const isProductPlatinumExclusive = tagIdList?.includes(
    Number(ProductTag.platinumExclusive)
  );

  const isLoyaltyLocked =
    isProductPlatinumExclusive &&
    isLockedToMember(tier?.label, LoyaltyTiers.PLATINUM);

  if (!isLoyaltyLocked) {
    return children;
  }

  return (
    <LockedTreatmentContainer>
      <OverlayWrapper>{children}</OverlayWrapper>
      <LockIconContainer>
        <LoyaltyLockIcon
          className="ml-[1px]"
          width={28}
          height={28}
          color="white"
        />
      </LockIconContainer>
    </LockedTreatmentContainer>
  );
};

ProductCardImageLockedTreatmentWrapper.propTypes = {
  children: PropTypes.node,
  tagIdList: PropTypes.array,
};

export default ProductCardImageLockedTreatmentWrapper;
